export const COMPANY_ADMIN = 'Company Admin'
export const BILLING_ADMIN = 'Billing Admin'
export const COMPANY_AGENT = 'Company Agent'
export const COMPANY_REPORTER_ACCESS = 'Company Reporter Access'
export const COMPANY_SUPERVISOR = 'Company Supervisor'

/**
 * The roles that keep account-wide visibility. Every other role, Supervisors
 * included, is scoped by Inbox membership. Kept as one list so the visibility
 * rules and the settings screens that describe them cannot drift apart.
 */
export const UNRESTRICTED_ROLES = [COMPANY_ADMIN, BILLING_ADMIN]
